import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import * as React from 'react';
import { classNames, responsiveClassNames } from "../../utils/helpers";
import s from './Divider.module.css';
export const Divider = (props) => {
    const { vertical, blank, className, attributes, color } = props;
    const rootClassNames = classNames(s.root, className, blank && s['--blank'], 
    // Possible override
    color && s[`--color-${color}`], ...responsiveClassNames(s, '--vertical', vertical));
    // Only support aria-orientation for non-responsive dividers
    let ariaOrientation;
    if (typeof vertical === 'boolean' || vertical === undefined) {
        ariaOrientation = vertical ? 'vertical' : 'horizontal';
    }
    return (_jsx("div", Object.assign({ "data-testid": "st-divider" }, attributes, { role: "separator", "aria-orientation": ariaOrientation, className: rootClassNames })));
};
